export default __webpack_public_path__ + "static/Plots0031-da1b1d94c221d470ed6e129e42c472ca.jpg";